import React, { View, StyleSheet } from "react-native"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"

export const SuccessBadge = ({
    text,
    withSuccessIndicator = true,
    startIcon,
    style,
}) => {
    return (
        <View style={[styles.successBadge, style]}>
            {startIcon ||
                (withSuccessIndicator && (
                    <View style={styles.successIndicator} />
                ))}
            <TextM
                fontSize={14}
                fontWeight="Medium"
                color={theme.colors.success}
            >
                {text}
            </TextM>
        </View>
    )
}

const styles = StyleSheet.create({
    successBadge: {
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: theme.colors.successLight,
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 20,
    },
    successIndicator: {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: theme.colors.success,
        marginRight: 8,
    },
})
